/**
 * 行业
 */

import { HTTP_ALB } from '../axios'
 
//行业列表
export const getIndustry = params => {
    return HTTP_ALB.get('/foundation/industry/list', params)
  }

//行业列表修改状态
export const postIndustryedit= params => {
    return HTTP_ALB.post('/foundation/industry/edit', params)
  }
  
  